import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, ElementRef, EventEmitter, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { RouterLink } from "@angular/router";
import { IconEmailComponent } from "@src/app/components/svg/icon-email/icon-email.component";
import { IconFacebookMaterialComponent } from "@src/app/components/svg/icon-facebook-material/icon-facebook-material.component";
import { IconInstagramComponent } from "@src/app/components/svg/icon-instagram/icon-instagram.component";
import { IconTelegramComponent } from "@src/app/components/svg/icon-telegram/icon-telegram.component";
import { IconTwitterComponent } from "@src/app/components/svg/icon-twitter/icon-twitter.component";
import { IconYoutubeComponent } from "@src/app/components/svg/icon-youtube/icon-youtube.component";
import { Subcanal } from "@src/app/models/interfaces/canal.interface";
import { FooterService } from "@src/app/servicios/footer.service";
import { PortadaService } from "@src/app/servicios/portada/portada.service";
import { firstValueFrom } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { NewsletterService } from "@src/app/servicios/newsletter/newsletter.service";

import { GoogleNewsBannerComponent } from "@src/app/componentes/google-news-banner/google-news-banner.component";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  imports: [FormsModule, ReactiveFormsModule, RouterLink, KebabCasePipe, CommonModule, IconEmailComponent, IconFacebookMaterialComponent, IconTwitterComponent, IconYoutubeComponent, IconInstagramComponent, IconTelegramComponent, GoogleNewsBannerComponent],
  providers: [NewsletterService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  subcanales: Subcanal[] = [];
  configBloque: any;
  configBloqueFooter: any;
  formulario: FormGroup;
  cookieConfig: boolean = false;
  mostrarFooter: boolean = true;
  showModal: boolean = false;
  mensaje: string;

  @Output() cookies = new EventEmitter();

  get email() {
    return this.formulario.get("email");
  }

  constructor(
    private readonly newsletterService: NewsletterService,
    private readonly portadaService: PortadaService,
    private readonly configService: ConfigService,
    private readonly elementRef: ElementRef,
    private readonly fb: FormBuilder,
    private readonly cd: ChangeDetectorRef,
    private readonly footerService: FooterService,
  ) {
    this.formulario = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });

    effect(() => {
      this.mostrarFooter = this.footerService.isPaginationFinished();
      this.cd.detectChanges();
    });
  }

  ngOnInit(): void {
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      firstValueFrom(configPrensa).then((resultConfig) => {
        if (resultConfig) {
          const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
          this.configBloqueFooter = resultConfig.general[selectorName];
          this.configBloque = resultConfig.general["app-newsletter"];
          if (resultConfig.general["app-modal-politica-co"]?.["is_consent"] === "true") {
            this.cookieConfig = true;
          }
          const showBloque = this.configBloque.bloque_activo === "true";
          if (showBloque) {
            this.portadaService.getCanal().subscribe((canales) => {
              this.subcanales = canales[0].subcanales?.filter((subcanal) => subcanal.activoPrensaFooter == "1") ?? [];
              this.cd.detectChanges();
            });
          }
        }
      });
    }
  }

  newsletterSubscribe(): void {
    if (this.email?.invalid) return;

    const userNewsletter = this.newsletterService.postUserNewsletter(this.email?.value);
    if (userNewsletter) {
      firstValueFrom(userNewsletter)
        .then((response) => {
          if (response.success) {
            this.showMessage(`Se ha completado la suscripción, pronto recibirás las novedades en <strong>${this.email?.value}</strong>`);
          }
        })
        .catch((error) => {
          if (error.status === 400) {
            this.showMessage(`El correo <strong>${this.email?.value}</strong> ya se encuentra registrado en esta Newsletter. Muchas gracias.`);
          } else {
            this.showMessage(`Lo sentimos. Hubo un problema al registrar su correo electrónico, inténtelo de nuevo más tarde.`);
          }
        });
    }
  }

  showMessage(message: string) {
    this.mensaje = message;
    this.showModal = true;
    this.cd.detectChanges();
  }

  closeModal() {
    this.showModal = false;
    this.formulario.reset();
  }

  configureCookies() {
    this.cookies.emit();
  }

  trackByCanal(canal: any): string | number {
    return canal?.idSubcanal ?? canal?.nombreSubCanal;
  }
}
